import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class MandatorySplitPaymentSinceNowWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.split-payment.mandatory-split-payment-since-now');
    }
}
